import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalSearch.GlobalSearchListItemTitle'

export default defineMessages({
  titleWithExtraIdentifier: {
    id: `${scope}.titleWithExtraIdentifier`,
    defaultMessage: '{label} #{id} – {extraIdentifier}',
  },
  titleWithoutExtraIdentifier: {
    id: `${scope}.titleWithoutExtraIdentifier`,
    defaultMessage: '{label} #{id}',
  },
  untitledContract: {
    id: `${scope}.untitledContract`,
    defaultMessage: 'Untitled contract',
  },
})
